import { CssBaseline, ThemeProvider } from '@mui/material'
import { appTheme } from 'theme'
import { RouterProvider } from 'react-router-dom'
import { appRouter } from 'routes/router'
import { AuthChecker } from 'hoc/AuthChecker'
import { store } from 'store'
import { Provider } from 'react-redux'
import { SidebarSettingsProvider } from 'providers/SidebarSettingsProvider'
import { ToastContainer } from 'react-toastify'
import './i18n'
import 'react-toastify/dist/ReactToastify.css'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import i18next from './i18n'
import 'dayjs/locale/az'
import 'dayjs/locale/en'
import { DefaultConfigAssigner } from 'hoc/DefaultConfigAssigner'
import './font.css'
import './global.css'

function App() {
  return (
    <ThemeProvider theme={appTheme}>
      <CssBaseline />
      <Provider store={store}>
        <LocalizationProvider
          dateAdapter={AdapterDayjs}
          adapterLocale={i18next.language}
        >
          <SidebarSettingsProvider>
            <AuthChecker>
              <DefaultConfigAssigner>
                <RouterProvider router={appRouter} />
                <ToastContainer
                  position="top-right"
                  autoClose={2500}
                  pauseOnFocusLoss={false}
                />
              </DefaultConfigAssigner>
            </AuthChecker>
          </SidebarSettingsProvider>
        </LocalizationProvider>
      </Provider>
    </ThemeProvider>
  )
}

export default App
